import React, { PropsWithChildren } from 'react';
import ReactModal from 'react-modal';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import useIsMobile from 'Hooks/Common/useIsMobile';

import { BaseModalProps } from './interfaces/UIModal';

import CloseIcon from 'Assets/images/icons/close-icon.svg';

function UIModal({
  onClose,
  children,
  className,
  overlayClassName,
  isOverlayTransparent = false,
  hideCloseIcon = false,
  shouldCloseOnOverlayClick = true,
}: PropsWithChildren<BaseModalProps>) {
  const isMobile = useIsMobile();
  return (
    <ReactModal
      className={classNames('modal__dialog', className, { mobile: isMobile })}
      overlayClassName={classNames('modal', overlayClassName, {
        'modal--transparent': isOverlayTransparent,
      })}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onRequestClose={onClose}
      isOpen
    >
      {!hideCloseIcon && (
        <ReactSVG src={CloseIcon} onClick={onClose} className="modal__close-button" />
      )}
      {children}
    </ReactModal>
  );
}

export default UIModal;
